var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowSmLeft = function SvgArrowSmLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    fillRule: "evenodd",
    d: "M9.658 15.492a1.166 1.166 0 0 1-1.65 0l-4.666-4.667a1.167 1.167 0 0 1 0-1.65l4.666-4.667a1.167 1.167 0 1 1 1.65 1.65L6.983 8.833h8.85a1.167 1.167 0 1 1 0 2.334h-8.85l2.675 2.675a1.167 1.167 0 0 1 0 1.65",
    clipRule: "evenodd"
  })));
};
export default SvgArrowSmLeft;